// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LIKE_BUTTON_LABEL = "L\u00edb\u00ed se mi";
